import React from 'react'


import Header from './templates/Header';
import Footer from './templates/Footer';
import SEO from './templates/SEO';


import about_img from "../assets/images/who-we-are-long.jpg"
import small_icon from "../assets/img/about/about_15.png"

import join_bg from "../assets/img/service/service__shape__1.png";
 
function About() {
  return (
    <div>

<SEO title="About Page"/>

<Header/>



{/* ****************************************** */}


<div class="aboutarea__5 sp_bottom_100 sp_top_50">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 col-lg-6 aos-init aos-animate" data-aos="fade-up">
                        <div class="aboutarea__5__img" data-tilt="" style={{ willChange: 'transform', transform: 'perspective(2000px) rotateX(0deg) rotateY(0deg)'}}>
                            <img loading="lazy" src={about_img} alt="about"/>
                        </div>
                    </div>

                    <div class="col-xl-6 col-lg-6 aos-init aos-animate" data-aos="fade-up">
                        <div class="aboutarea__content__wraper__5">
                            <div class="section__title">
                                <div class="section__title__button">
                                    <div class="default__small__button">About Trading Whales</div>
                                </div>
                                <div class="section__title__heading ">
                                    <h2>Your Gateway to Financial Freedom</h2>
                                    <p>Hyderabad | Vizag | Vijayawada</p>
                                </div>
                            </div>
                            <div class="about__text__5">
                                <p>At TradingWhales, we believe that financial literacy is not just a skill—it's a pathway to empowerment and success. Founded with a passion for demystifying the world of finance, we are committed to transforming how individuals learn, trade, and invest in today’s dynamic market.</p>
                            </div>

                            <div class="aboutarea__5__small__icon__wraper">
                                <div class="aboutarea__5__small__icon">
                                    <img loading="lazy" src={small_icon} alt="about"/>

                                </div>
                                <div class="aboutarea__small__heading">
                                    <span>10+ Years of hands-on expertise </span> in the world of stock markets and trading education.
                                </div>

                            </div>




                            {/* <div class="aboutarea__para__5">
                                <p>I love to work in User Experience &amp; User Interface designing. Because I love to solve the design problem and find easy and better solutions to solve it. I always try my best to make good user interface with the best user
                                    experience. I have been working as a UX Designer</p>
                            </div> */}

                            <div class="aboutarea__bottom__button__5">
                                <a class="default__button" href="/contact"> Contact Us
                                        <i class="icofont-long-arrow-right"></i>
                                    </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

{/* *************************************************** */}


<div class="abouttabarea sp_bottom_70">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12 aos-init aos-animate" data-aos="fade-up">
                        <ul class="nav  about__button__wrap" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="single__tab__link" data-bs-toggle="tab" data-bs-target="#projects__one" type="button" aria-selected="false" role="tab" tabindex="-1">Who We Are</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="single__tab__link" data-bs-toggle="tab" data-bs-target="#projects__two" type="button" aria-selected="false" tabindex="-1" role="tab">Our Mission</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="single__tab__link active" data-bs-toggle="tab" data-bs-target="#projects__three" type="button" aria-selected="true" role="tab">What We Offer</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="single__tab__link" data-bs-toggle="tab" data-bs-target="#projects__four" type="button" aria-selected="false" tabindex="-1" role="tab">Our Values</button>
                            </li>


                        </ul>
                    </div>



                    <div class="tab-content tab__content__wrapper aos-init aos-animate" id="myTabContent" data-aos="fade-up">

                        <div class="tab-pane fade" id="projects__one" role="tabpanel" aria-labelledby="projects__one">
                            <div class="col-xl-12">
                                <div class="aboutarea__content__tap__wraper">
                                   
                                    <div class="aboutarea__tap__heading">
                                        <h5>WHO WE ARE</h5>
                                        <p class="paragraph__1">TradingWhales is a tech-driven, omni-channel financial education platform that combines digital innovation with in-person learning. Our journey began with a simple vision: to make comprehensive financial market education accessible and affordable to everyone, regardless of their background. Today, we serve a diverse community of learners, from curious beginners to seasoned traders, with tailored courses that cover every facet of the financial world.</p>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div class="tab-pane fade" id="projects__two" role="tabpanel" aria-labelledby="projects__two">

                        <div class="aboutarea__content__tap__wraper">
                                   
                                   <div class="aboutarea__tap__heading">
                                       <h5>OUR MISSION</h5>
                                       <p class="paragraph__1">Our mission is to empower individuals with the knowledge and skills necessary to navigate the complexities of global financial markets. By fostering an environment of continuous learning and practical application, we aim to transform financial aspirations into tangible success stories.</p>
                                   </div>

                               </div>

                        </div>

                        <div class="tab-pane fade active show" id="projects__three" role="tabpanel" aria-labelledby="projects__three">
                            <div class="col-xl-12">
                                <div class="aboutarea__content__tap__wraper">

                                <div class="aboutarea__tap__heading">
                                       <h5>WHAT WE OFFER</h5>
                                       <p class="paragraph__1">Expert-Led Courses: Our curriculum is designed by industry professionals and financial experts, ensuring you receive practical insights and up-to-date knowledge. </p>
                                   </div>
                                <div class="aboutarea__tap__heading">
                                       <h5>Expert-Led Courses:</h5>
                                       <p class="paragraph__1">Our curriculum is designed by industry professionals and financial experts, ensuring you receive practical insights and up-to-date knowledge.</p>
                                   </div>
                                <div class="aboutarea__tap__heading">
                                       <h5>Hybrid Learning Experience:</h5>
                                       <p class="paragraph__1">With a blend of online live classes, recorded sessions, and interactive classroom programmes at our state-of-the-art centres, learning is flexible and engaging.</p>
                                   </div>
                                <div class="aboutarea__tap__heading">
                                       <h5>Community-Driven Support:</h5>
                                       <p class="paragraph__1">At TradingWhales, you're never alone. Our dedicated support team, interactive forums, and one-on-one mentoring ensure that help is always just a click away.</p>
                                   </div>
                                <div class="aboutarea__tap__heading">
                                       <h5>Cutting-Edge Tools & Resources:</h5>
                                       <p class="paragraph__1">We provide the latest market insights, analytical tools, and real-time data to help you make informed decisions and stay ahead of the curve. </p>
                                   </div>


                                </div>

                            </div>
                        </div>

                        <div class="tab-pane fade" id="projects__four" role="tabpanel" aria-labelledby="projects__four">
                            <div class="col-xl-12">
                                <div class="aboutarea__content__tap__wraper">
                                <div class="aboutarea__tap__heading">
                                       <h5>OUR VALUES</h5>
                                       </div>

                                       <div class="aboutarea__tap__heading">
                                       <h5>Accessibility:</h5>
                                       <p class="paragraph__1"> We are committed to breaking down barriers to financial education, making learning accessible to everyone. </p>
                                   </div>
                                 
                                       <div class="aboutarea__tap__heading">
                                       <h5>Integrity:</h5>
                                       <p class="paragraph__1">Trust and transparency form the backbone of our operations. We strive for honesty in every lesson and every interaction. </p>
                                   </div>
                                 
                                 
                                       <div class="aboutarea__tap__heading">
                                       <h5>Innovation:</h5>
                                       <p class="paragraph__1"> Embracing the future of education, we continuously integrate innovative technologies to enhance your learning experience.    </p>
                                   </div>
                                 
                                       <div class="aboutarea__tap__heading">
                                       <h5>Community:</h5>
                                       <p class="paragraph__1">We believe in the power of collaboration and shared growth. Our community is a space where ideas flourish and support is unwavering.</p>
                                   </div>
                                 
                                  
                                </div>

                            </div>
                        </div>



                    </div>


                </div>
            </div>
        </div>


{/* ********************************************* */}


<div class="populerarea__2 sp_top_50  sp_bottom_50">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 about__wrap__content aos-init aos-animate" data-aos="fade-up">
                        <div class="service__animate__shape__1">
                            <img loading="lazy" src={join_bg} alt=""/>
                        </div>
                        <div class="populerarea__content__wraper__2">
                            <div class="section__title ">
                                <div class="section__title__button">
                                    {/* <div class="default__small__button">Populer Subject</div> */}
                                </div>
                                <div class="section__title__heading">
                                    <h2>Our Impact</h2>
                                </div>
                            </div>

                            <div class="populerarea__content__2">
                                {/* <p class="populerarea__para__1">Construction is a general term meaning the art and science to form systems organizations, and comes from Latin Construction is</p> */}
                                <p class="populerarea__para__2">Since our inception, TradingWhales has reached hundreds of thousands of learners across India. With an ever-growing network of hybrid learning centres, digital resources, and a vibrant community of financial enthusiasts, we have successfully transformed the learning landscape—empowering individuals to make confident, informed decisions in the financial markets.</p>
                            </div>
                            {/* <div class="populerarea__button__2">
                                <a class="default__button" href="/contact">Contact Us
                            <i class="icofont-long-arrow-right"></i>
                        </a>
                            </div> */}
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 service__wrap__content">
                        <div class="service__animate__shape__2">
                            <img loading="lazy" src="" alt=""/>
                        </div>
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-6 col-sm-12 aos-init aos-animate" data-aos="fade-up">
                                <div class="single__service">
                                    <div class="service__img">

                                        <svg class="service__icon" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.30281 28.9536H8.45394C9.05625 28.9536 9.48648 29.5426 9.48648 30.2495V36.8465C9.48648 37.6711 9.05625 38.2602 8.45394 38.2602H6.30281C5.78654 38.2602 5.27026 37.6711 5.27026 36.8465V30.2495C5.27026 29.5426 5.78654 28.9536 6.30281 28.9536Z" fill="#F4B942"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7027 23.7833H15.8987C16.4257 23.7833 16.8649 24.4239 16.8649 25.3207V36.7228C16.8649 37.6196 16.4257 38.2602 15.8987 38.2602H13.7027C13.0879 38.2602 12.6487 37.6196 12.6487 36.7228V25.3207C12.6487 24.4239 13.0879 23.7833 13.7027 23.7833Z" fill="#F4B942"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.0596 19.6471H23.2108C23.727 19.6471 24.2433 20.412 24.2433 21.1769V36.7303C24.2433 37.6227 23.727 38.2602 23.2108 38.2602H21.0596C20.4573 38.2602 20.0271 37.6227 20.0271 36.7303V21.1769C20.0271 20.412 20.4573 19.6471 21.0596 19.6471Z" fill="#F4B942"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M28.4381 15.5109H30.5892C31.1055 15.5109 31.6217 16.1499 31.6217 17.0445V36.7265C31.6217 37.6212 31.1055 38.2602 30.5892 38.2602H28.4381C27.8357 38.2602 27.4055 37.6212 27.4055 36.7265V17.0445C27.4055 16.1499 27.8357 15.5109 28.4381 15.5109Z" fill="#F4B942"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M26.9989 7.6293L23.05 18.137L20.3744 15.4678C15.622 19.6266 9.96272 22.5976 3.63238 24.2568C1.36694 24.9297 0.353173 21.6176 2.74495 21.0505C8.47735 19.533 13.5443 16.8156 17.8363 13.1279L15.5453 10.8879L26.9989 7.6293Z" fill="#479536"></path>
                                        </svg>



                                        <div class="service__bg__img">
                                            <svg class="service__icon__bg" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M63.3775 44.4535C54.8582 58.717 39.1005 53.2202 23.1736 47.5697C7.2467 41.9192 -5.18037 32.7111 3.33895 18.4477C11.8583 4.18418 31.6595 -2.79441 47.5803 2.85105C63.5011 8.49652 71.8609 30.2313 63.3488 44.4865L63.3775 44.4535Z" fill="#F4B942" fill-opacity="0.05"></path>
                                        </svg>
                                        </div>
                                    </div>
                                    <div class="service__content service__content__2">
                                        <h3><a href="/contact">Join Us on the Journey</a></h3>
                                        <p>At TradingWhales, every learner is part of our family. Whether you’re taking your first step in the world of finance or looking to sharpen your trading strategies, we invite you to join us and be a part of this transformative journey.</p>
                                    </div>
                                    <div class="service__button">
                                        <a href="/contact">Join Us
                                        <i class="icofont-long-arrow-right"></i>
                                    </a>
                                    </div>
                                    <div class="service__small__img">
                                        <svg class="icon__hover__img" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.5961 10.265L19 1.33069L10.0022 3.73285L1 6.1306L7.59393 12.6627L14.1879 19.1992L16.5961 10.265Z" stroke="#fb6107" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    </div>
                                </div>


                            </div>



                        </div>
                    </div>
                </div>
            </div>
        </div>

















<Footer/>
      
    </div>
  )
}

export default About
